export default "__VITE_ASSET__DcJDm3Lu__"